var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9766 82H65.0234C68.9975 82 72.2305 78.7671 72.2305 74.793V24.0234H55.4141C51.4399 24.0234 48.207 20.7905 48.207 16.8164V0H16.9766C13.0024 0 9.76953 3.23291 9.76953 7.20703V74.793C9.76953 78.7671 13.0024 82 16.9766 82ZM26.5859 33.793H55.4141C56.7419 33.793 57.8164 34.8675 57.8164 36.1953C57.8164 37.5232 56.7419 38.5977 55.4141 38.5977H26.5859C25.2581 38.5977 24.1836 37.5232 24.1836 36.1953C24.1836 34.8675 25.2581 33.793 26.5859 33.793ZM26.5859 43.4023H55.4141C56.7419 43.4023 57.8164 44.4768 57.8164 45.8047C57.8164 47.1325 56.7419 48.207 55.4141 48.207H26.5859C25.2581 48.207 24.1836 47.1325 24.1836 45.8047C24.1836 44.4768 25.2581 43.4023 26.5859 43.4023ZM26.5859 53.0117H55.4141C56.7419 53.0117 57.8164 54.0862 57.8164 55.4141C57.8164 56.7419 56.7419 57.8164 55.4141 57.8164H26.5859C25.2581 57.8164 24.1836 56.7419 24.1836 55.4141C24.1836 54.0862 25.2581 53.0117 26.5859 53.0117ZM26.5859 62.6211H45.8047C47.1325 62.6211 48.207 63.6956 48.207 65.0234C48.207 66.3513 47.1325 67.4258 45.8047 67.4258H26.5859C25.2581 67.4258 24.1836 66.3513 24.1836 65.0234C24.1836 63.6956 25.2581 62.6211 26.5859 62.6211Z",
    fill: "url(#paint0_linear_1155_13927)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4141 19.2174H70.8229L53.0117 1.40625V16.815C53.0117 18.1405 54.0886 19.2174 55.4141 19.2174Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4141 19.2174H70.8229L53.0117 1.40625V16.815C53.0117 18.1405 54.0886 19.2174 55.4141 19.2174Z",
    fill: "url(#paint1_linear_1155_13927)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1155_13927",
    x1: 41,
    y1: 0,
    x2: 41,
    y2: 82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1155_13927",
    x1: 61.9173,
    y1: 1.40625,
    x2: 61.9173,
    y2: 19.2174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.38e237e57a35e54d00c231fc4327441c.svg";
export { ForwardRef as ReactComponent };